



import { Component, Prop, Vue, Inject } from 'vue-property-decorator';
import StpDetail from '@/components/stp/StpDetail.vue';
import { Anagrafica } from '@/models/anagrafica.model';
import { AnagraficaService } from '@/services/anagrafica.service';


@Component({
	components: {
		StpDetail
	}
})

export default class IscrittoStp extends Vue {

	@Inject('AnagraficaService')
	anagraficaService!: AnagraficaService;

	@Prop() id!: number;

	loading: boolean = false;
	anagrafica!: Anagrafica;

	constructor() {
		super();
	}

	beforeMount() {
		this.loading = true;
		const loadingCmp = this.$buefy.loading.open({});
		this.anagraficaService.getAnagrafica(this.id).then(result => {
			this.anagrafica = result;
		}).finally(() => {
			loadingCmp.close();
			this.loading = false;
		})
	}
}
